export default __webpack_public_path__ + "static/media/co_national_back.3404c05a.jpeg";